document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabImages = document.querySelectorAll('.tab-image');

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabImages.forEach(img => img.classList.remove('active'));

      button.classList.add('active');
      document.querySelector(`.tab-image[data-tab="${index}"]`).classList.add('active');
    });
  });
});
